import { render } from "./HelloWorld.vue?vue&type=template&id=a87ea5ee&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=a87ea5ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brinl\\Desktop\\FnixApp\\LatestsUpload\\fnx\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87ea5ee"]])

export default __exports__